<template>
    <section>
        <!-- Карточка здания -->
        <section class="gz-info-card">
            <!-- Данные о здании -->
            <section class="gz-info-card__info">
                <span v-if="isShelter" @click="$router.push('/admin/address/' + buildingData.id + '/view-all')" class="gz-info-card__item icon-home-run"></span>
                <span class="gz-info-card__item">
                    <strong>Нас.пункт:&nbsp;</strong>
                    {{  buildingDataComputed && buildingDataComputed.citytype }}
                    {{  buildingDataComputed && buildingDataComputed.city }}
                </span>
                <span class="gz-info-card__item">
                    <strong>Улица:&nbsp;</strong>{{ buildingDataComputed && buildingDataComputed.street }}
                </span>
                <span class="gz-info-card__item">
                    <strong>Дом:&nbsp;</strong>{{ buildingDataComputed && buildingDataComputed.number }}
                </span>

                <span class="gz-info-card__item">
                    <strong>Юр лицо:&nbsp;</strong>{{buildingServiceEntity}}
                </span>
                <span class="gz-info-card__item">
                    <strong>Тип:&nbsp;</strong>{{ buildingDataComputed && enumFilterMap('get', buildingDataComputed.type, this.$store.getters['filterBuildingType']) }}
                </span>
                        
                <span class="gz-info-card__item">
                    <strong>Помещений:&nbsp;{{ propertyCount }}</strong>
                </span>
                <span class="gz-info-card__item">
                    <strong>Этажей:&nbsp;</strong>{{ buildingDataComputed && buildingDataComputed.levelNum ? buildingDataComputed.levelNum : '--' }}
                </span>
                <span class="gz-info-card__item">
                    <strong>Подъездов:&nbsp;</strong>{{ buildingDataComputed && buildingDataComputed.porchNum ? buildingDataComputed.porchNum : '--' }}
                </span>
            </section>
            <!-- Дополнительные данные и опции -->
            <section class="gz-info-card__informers">
                <CommentsAndNotes 
                    :show="!isShelter" 
                    :modalData="{id: $route.params.id, url: 'building'}"
                />
                <NextCheckupDate 
                    v-if="buildingDataComputed && buildingDataComputed.nextCheckupDate" 
                    :date="buildingDataComputed.nextCheckupDate"
                    type="building"
                    :id="$store.getters['addressesBuilding'].id"

                /> 
            </section>
        </section>

        <!-- Карточка помещения -->
        <section v-if="isShelter" class="gz-info-card">
            <!-- Данные о помещении -->
            <section class="gz-info-card__info">
                <span class="gz-info-card__item icon-d"></span>
                <span class="gz-info-card__item">
                    <strong>Владелец:&nbsp;</strong>
                        {{ userDataComputed && userDataComputed.lname }} 
                        {{ userDataComputed && userDataComputed.fname ? userDataComputed.fname.charAt(0) : ''}}.
                        {{ userDataComputed && userDataComputed.pname ? userDataComputed.pname.charAt(0) : '' }}
                    </span>
                <span class="gz-info-card__item">
                    <strong>Подъезд:&nbsp;</strong>{{ shelterDataComputed && shelterDataComputed.porch }}</span>
                <span class="gz-info-card__item">
                    <strong>Этаж:&nbsp;</strong>{{ shelterDataComputed && shelterDataComputed.level }}</span>
                <span class="gz-info-card__item">
                    <strong>Квартира:&nbsp;</strong>{{ shelterDataComputed && shelterDataComputed.number }}</span>
            </section>
            <!-- Дополнительные данные и опции -->
            <section class="gz-info-card__informers">
                <CommentsAndNotes 
                    :modalData="{id: $route.params.id, url: 'property'}"
                />
                <NextCheckupDate 
                    v-if="shelterDataComputed && shelterDataComputed.nextCheckupDate" 
                    :date="shelterDataComputed.nextCheckupDate" 
                    type="shelter"
                    :id="$store.getters['addressesShelter'].id"
                />                
            </section>
        </section>
    </section>
</template>

<script>
import NextCheckupDate from './BaseNextCheckupDate'
import CommentsAndNotes from './BaseCommentsAndNotes'
import moment from 'moment'
var qs = require('qs');

export default {
    name: 'AddressCard',

    props: {
        isShelter: {
            type: Boolean,
            default: false
        }
    },
    components: {
        NextCheckupDate,
        CommentsAndNotes
    },
    data() {
        return {
            buildingData: {},
            shelterData: {},
            userData: {},
            buildingServiceEntity: '',
            propertyCount: null,
            buildingLoading: false,
            shelterLoading: false
        }
    },
    computed: {
        buildingDataComputed() {
            return this.buildingData.attributes
        },
        shelterDataComputed() {
            return this.shelterData.attributes
        },
        userDataComputed() {
            return this.userData.attributes
        }
    },
    async mounted() {
        if (this.isShelter) {
            //Если на странице помещения, то сначала получим данные о помещении, а затем о доме
            this.$store.dispatch('addressesGetShelter', this.$route.params.id)
                .then(() => {
                    this.shelterData = this.$store.getters['addressesShelter']
                
                    this.$store.dispatch('addressLocation', 'property') //Определяет здание или помещение, для отображение кнопки комментариев
                    this.$store.dispatch('notificationStaticMessage', this.shelterData.attributes.notes)
                
                    return this.shelterData.attributes   
                })
                .then(result => {
                    this.$store.dispatch('addressesGetBuilding', result.bid)
                        .then(() => {
                            this.buildingData = this.$store.getters['addressesBuilding']
                        })
                        .catch(err => {
                            console.error('Ошибка получения данных о доме при загрузке карточки помещения: ', err)
                        })
                    
                    return result
                })
                .then(result => {
                    this.$store.dispatch('addressesGetUser', result.profid)
                        .then(() => {
                            this.userData = this.$store.getters['addressesUser']
                        })
                        .catch(err => {
                            console.error('Ошибка получения данных о пользователе при загрузке карточки помещения: ', err)
                        })
                })
                .catch(err => {
                    console.error('Ошибка получения данных помещения для карточки помещения: ', err)
                })
            
        } 
        if (!this.isShelter) {
            //Если на странице адреса, то получаем данные только о здании
            this.$store.dispatch('addressesGetBuilding', this.$route.params.id)
                .then(() => {
                    this.buildingData = this.$store.getters['addressesBuilding']

                    return this.buildingData.attributes.seid
                })
                .then(() => {
                    this.$store.dispatch('addressLocation', 'building') //Определяет здание или помещение, для отображение кнопки комментариев
                    this.$store.dispatch('notificationStaticMessage', this.buildingData.attributes.notes)
                })
                .then(() => {
                    
                })
                .catch(err => {
                    console.error('Ошибка загрузки данных о здании для карточки адреса: ', err)
                })

            
            try {
                const result = await this.$axios({
                    method: 'GET',
                    url: '/property/count',
                    params: {
                        buildingIdList: JSON.stringify([this.$route.params.id])
                    }
                })
        
                this.propertyCount = result.data[0].count
            } catch(e) {
                
                console.log(e)
            }           

        }
    },
    beforeDestroy() {
        this.$store.dispatch('notificationStaticMessage', '')
    },
    methods: {
        moment() {
            return moment()
        }
    }
}
</script>